/**
 *
 * useSubmitStatus
 * Run a form's request once at a time and track whether it is busy or failed,
 * so the form can disable its submit button and show an error.
 * Status is one of 'idle', 'busy' or 'failed'.
 *
 */

import { useRef } from 'react';
import useSafeState from 'utils/useSafeState';
import { reportError } from 'utils/Sentry';

function useSubmitStatus() {
  const [status, setStatus] = useSafeState('idle');
  // A ref, unlike status, is up to date even before React re-renders
  const busy = useRef(false);

  async function submit(request, onSuccess) {
    if (busy.current) {
      return;
    }
    busy.current = true;
    setStatus('busy');
    try {
      // Stay busy after success: onSuccess usually navigates away
      onSuccess(await request());
    } catch (err) {
      reportError(err, { status: err?.response?.status });
      busy.current = false;
      setStatus('failed');
    }
  }

  return [status, submit];
}

export default useSubmitStatus;
